import {AxiosRequestConfig} from 'axios';

import request from '../../axios';

interface IAdvertisementProps {
  search?: string;
  selected_cities_id?: string;
  advertisement_type?: string;
  input_guid?: string;
  ordering?: string;
  start_price?: number;
  has_store?: boolean;
  end_price?: number;
  has_special_offer?: boolean;
  has_price?: boolean;
  has_immediate?: boolean;
}

const getAdvertisements = async (payload: IAdvertisementProps) => {
  const {data}: {data: IInputGroupsAdvertisement} = await request.get(
    'api/v2/store/supplier-advertisement-list',
    {
      params: payload,
    } as AxiosRequestConfig,
  );

  return data;
};

export default getAdvertisements;
